import { gsap } from 'gsap';
import Vue from 'vue';

Vue.component('promo-article-wrapper', {
    props: {
        financingTypeDropdownValues: {
            value: Array,
        },
    },

    data() {
        return {
            financePlan: null,
            selectedModel: null, // Add this line
            allFinancePlans: JSON.parse(this.financingTypeDropdownValues),
            selectedAccordionModel: null,
            selectedTooltipPromo: null,
        };
    },

    mounted() {
        this.getFinancePlanFromQueryParameters();
        this.toggleOpenAccordion(this.financePlan, 'financePlan');
        // Set initial model if finance plan exists
        if (this.financePlan) {
            this.selectedModel = this.financePlan;
        }
        EventBus.$on('promo-financing-type-set', (financingTypeValue) => {
            this.financePlan = financingTypeValue;
        });
    },

    methods: {
        getFinancePlanFromQueryParameters() {
            const urlParams = new URLSearchParams(window.location.search);
            const financePlan = urlParams.get('finance_plan');
            if (!financePlan) return;
            this.financePlan = financePlan;

            const selectedPlan = this.allFinancePlans.find(
                (plan) => plan.value === financePlan,
            );

            if (!selectedPlan) return;
            EventBus.$emit('promo-article-finance-plan-set', selectedPlan);
        },

        changeSelectedPlan(planProp) {
            const selectedPlan = this.allFinancePlans.find(
                (plan) => plan.value === planProp,
            );

            if (!selectedPlan) return;
            EventBus.$emit('promo-article-finance-plan-set', selectedPlan);
            this.toggleOpenAccordion(planProp, 'financePlan');
            this.financePlan = planProp;

            // Update URL parameter without adding to history
            const url = new URL(window.location);
            url.searchParams.set('finance_plan', planProp);
            window.history.replaceState({}, '', url);
        },

        checkIsPlanCardSelected(plan) {
            return this.financePlan === plan
                ? 'promo-article-compare-plan-card--active'
                : '';
        },

        slugifyModelName(modelName, index) {
            if (/[a-zA-Z]/.test(modelName)) {
                return modelName
                    .replace(/\s+/g, '-') // Replace spaces with hyphens
                    .toLowerCase();
            }

            return `model-${modelName.replace(/[€,]/g, '')}-${index}`;
        },

        changeSelectedModel(model, index) {
            const slugifiedModelName = this.slugifyModelName(model, index);
            this.toggleOpenAccordion(
                slugifiedModelName,
                'selectedAccordionModel',
            );
            this.selectedAccordionModel = slugifiedModelName;
        },

        toggleOpenAccordion(containerClass, propToCheck) {
            // Reset all chevrons first
            const allChevrons = document.querySelectorAll(
                '.promo-article-compare-plan-card__button__chevron, .promo-campaign-prices-accordion__button__chevron',
            );
            allChevrons.forEach((chevron) => {
                gsap.to(chevron, {
                    duration: 0,
                    rotate: 0,
                });
            });

            const container = document.querySelector(`.${containerClass}`);
            const chevron = document.querySelector(
                `.promo-article-compare-plan-card__button__chevron--${containerClass}`,
            );
            const buttonChevron = document.querySelector(
                `.promo-campaign-prices-accordion__button__chevron--${containerClass}`,
            );

            if (this[propToCheck]) {
                const oldSelectedPlan = document.querySelector(
                    `.${this[propToCheck]}`,
                );
                if (oldSelectedPlan) {
                    const timeline = gsap.timeline();
                    timeline.to(oldSelectedPlan, {
                        duration: 0.7,
                        height: 0,
                        ease: 'power4.out',
                    });
                }
            }

            if (container.clientHeight > 0) {
                this.selectedTooltipPromo = null;
            }

            const timeline = gsap.timeline();
            timeline
                .to(
                    container,
                    {
                        duration: 0.7,
                        height: container.clientHeight > 0 ? 0 : 'auto',
                        ease: 'power4.out',
                    },
                    'start',
                )
                .to(
                    [chevron, buttonChevron].filter(Boolean),
                    {
                        duration: 0,
                        rotate: container.clientHeight > 0 ? 0 : -180,
                    },
                    'start',
                );
        },

        togglePriceTooltip(selectedTooltipPromo) {
            if (this.selectedTooltipPromo === selectedTooltipPromo) {
                this.selectedTooltipPromo = null;
                return;
            }
            this.selectedTooltipPromo = selectedTooltipPromo;
        },

        togglePriceTooltipActiveClass(tooltipPromo) {
            return this.selectedTooltipPromo === tooltipPromo
                ? 'model-header__toolbar-text--active'
                : '';
        },

        // This is here because CraftCMS creates ternary operator that checks if cached file exists.
        // This happens when you add a link to a file on a CDN that's on the same environment as the website.
        // This logic probably shouldn't even exist here because twig should handle this on it's own.
        // But since we're creating a logic where everything is parsed and showed through Vue, which I think is a bad idea in general,
        // I think that this should be parsed on the backend and then passed to Vue.
        // For now this is the best solution I could come up with.
        parseDisclaimerForInternalLinks(disclaimer) {
            if (!disclaimer?.length) return;

            const assetRegex = /\{asset:\d+:url\|\|([^}]+)\}/g;
            const entryRegex = /\{entry:(\d+)(@\d+)?:url\|\|([^}]+)\}/g;
            const isLinkInDisclaimer = disclaimer.includes('<a');

            if (!isLinkInDisclaimer) return disclaimer;

            return disclaimer
                .split('<a')
                .map((item) => item.replace(assetRegex, '$1'))
                .map((item) => item.replace(entryRegex, '$3'))
                .join('<a');
        },
    },
});
